import { ReactComponent as Warning } from './assets/ic_error_warning.svg';
import { ReactComponent as NoAddress } from './assets/ic_no_address.svg';
import { ReactComponent as NoOrders } from './assets/ic_chef_no_orders.svg';
import { ReactComponent as NoPickup } from './assets/ic_nopickup.svg';
import { ReactComponent as NoDelivery } from './assets/ic_nodelivery.svg';
import { ReactComponent as NotInArea } from './assets/ic_welcomeError_notInArea.svg';
import { ReactComponent as NotCreditCard } from './assets/ic_no_credit_card.svg';
import { ReactComponent as NoCompanies } from './assets/ic_nocompanies.svg';

export const ERROR_IMAGES = {
  WARNING: Warning,
  NO_ADDRESS: NoAddress,
  NO_ORDERS: NoOrders,
  NO_PICKUP: NoPickup,
  NO_DELIVERY: NoDelivery,
  NOT_IN_AREA: NotInArea,
  NO_COUPONS: NoAddress,
  NO_CREDIT_CARDS: NotCreditCard,
  NO_COMPANIES: NoCompanies
};
